var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { class: _vm.$style.formContainer },
    [
      _c("LogoIcon", { attrs: { fixed: false } }),
      _vm._v(" "),
      _c("h1", { class: _vm.$style.header }, [
        _vm._v("\n    Update your password in 3 easy steps\n  "),
      ]),
      _vm._v(" "),
      _c(
        "ol",
        { class: _vm.$style.directions },
        _vm._l(_vm.steps, function (step) {
          return _c(
            "li",
            { key: step.step, class: _vm.$style.directionsItem },
            [_vm._v("\n      " + _vm._s(step.text) + "\n    ")]
          )
        }),
        0
      ),
      _vm._v(" "),
      _c("img", { class: _vm.$style.image, attrs: { src: _vm.image } }),
      _vm._v(" "),
      _c("small", { class: _vm.$style.disclaimer }, [
        _vm._v(
          "\n    * If TOTP MFA is enabled you will be prompted after confirm password to enter your TOTP code.\n  "
        ),
      ]),
      _vm._v(" "),
      _vm.$route.query.key
        ? _c(
            "a",
            { class: _vm.$style.link, attrs: { href: _vm.resetUserPassword } },
            [_vm._v("\n    I don't see how, continue to portal\n  ")]
          )
        : _vm._e(),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }